import ListLayout from "../../../components/layout/main/ListLayout";
import { PageCard } from "../../../styles/CommonStyles";
import { useState } from "react";
import ModalLayout from "../../../components/layout/main/ModalLayout";
import Tooltip from "../../../components/common/utils/Tooltip";
import { AddIcon } from "../../../styles/main/setting";
import { useGetPackages } from "../../../core/services/react-query/setting/package";
import PackageListing from "../../../components/main/setting/package/PackageListing";
import PackageModal from "../../../components/main/setting/package/PackageModal";
import { useWindowSize } from "../../../core/hooks/common/useWindowSize";
import { MOBILE_SIZE } from "../../../core/constants/common";
import RPackageListTable from "../../../components/main/setting/package/RPackageListing";


const PackagePage = () => {
    const { data: packages, isLoading } = useGetPackages();
    const { width } = useWindowSize()
    const [packageModal, setPackageModal] = useState(false)
    const closePackageModal = () => setPackageModal(false)
    const openPackageModal = () => setPackageModal(true)

    return (
        <ListLayout>
            <PageCard>
                <Tooltip content={'add-category'}>
                    <div onClick={openPackageModal}>
                        <AddIcon size={24} />
                    </div>
                </Tooltip>
                {
                    width <= MOBILE_SIZE ? <RPackageListTable isLoading={isLoading} packages={packages?.data?.data} /> :
                        <PackageListing isLoading={isLoading} packages={packages?.data?.data} />
                }
            </PageCard>
            <ModalLayout
                width={'650px'}
                open={packageModal}
                onClose={closePackageModal}
            >
                <PackageModal
                    existingPackages={packages}
                    onSuccess={closePackageModal}
                    closeModal={closePackageModal}
                />
            </ModalLayout>
        </ListLayout>
    )
}

export default PackagePage
